import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { PlatformDataService } from '@zhik/core/services/platform-data';
import { FooterCardComponent } from './footer-card/footer-card.component';
import { FooterIconsComponent } from './footer-icons/footer-icons.component';
import { FooterAddressComponent } from './footer-address/footer-address.component';
import { FooterLinksComponent } from './footer-links/footer-links.component';
import { FooterLogoComponent } from './footer-logo/footer-logo.component';

@Component({
  selector: 'dskhome-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [
    MatButton,
    MatIcon,
    FooterCardComponent,
    FooterIconsComponent,
    FooterAddressComponent,
    FooterLinksComponent,
    FooterLogoComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly platformDataService = inject(PlatformDataService);

  scrollToTop(): void {
    this.platformDataService.window?.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
